"use client";

import UpcomingEvents from "@/modules/events/components/upcoming-events";
import HottestDiscussions from "@/modules/home/components/hottest-discussions";
import ProductListing from "./product-listing";
import FeaturedNews from "@/modules/home/components/product-listing/components/featured-news";
import { JobBoard } from "./job-board";
import { useCountryContext } from "@/providers/country-provider";
import { HomepageRightSidebar } from "@/modules/home/components/product-listing/product-listing";

function ProductsPostsEvents() {
	const { featuredVideo } = useCountryContext();
	return (
		<section className="mt-8 px-4 pb-14 sm:mt-16 md:px-8">
			<div className="mb-8 grid gap-4 md:mb-16 md:grid-cols-3 lg:gap-20">
				{/* Main feed */}
				<div className="gap-8 md:col-span-2 md:gap-16">
					<ProductListing disableSearchFilter={false} />

					<div className="overflow-hidden">
						<HottestDiscussions />
					</div>
				</div>

				<HomepageRightSidebar featuredVideo={featuredVideo} enable={{ onlineUsers: true }} />
			</div>

			{/* Other sections */}
			<UpcomingEvents />
			<FeaturedNews />
			<JobBoard />
		</section>
	);
}

export default ProductsPostsEvents;
